import React from 'react'

type SkodaPopupWindowProps = {
	title: string;
	text: string;
	closeButtonText: string;
	onClose: () => void;
};

export const SkodaPopupWindow: React.FC<SkodaPopupWindowProps> = (props) => (
	<div className="modal">
		<div className="modal_content">
			<span className="modal_closeIcon" onClick={props.onClose}>&times;</span>
			<h5 className="modal_title">{props.title}</h5>
			<p className="modal_text">{props.text}</p>
			<button className="modal_buttonClose" onClick={props.onClose}>{props.closeButtonText}</button>
		</div>
	</div>
);
